import { BaseRouteService } from 'core/services';

class PrintNodeInfoRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'print-node-infos/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	getPrinters(apiKey) {
		return super.get(this.base + 'printers/{id}', apiKey);
	}
}

export default PrintNodeInfoRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/PrintNodeInfoRouteService.js